import Hero from '../components/Hero/Hero';
import Stats from '../components/Stats/Stats';
import AboutIntro from '../components/About/AboutIntro';
import Services from '../components/Services/Services';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import Fleet from '../components/Fleet/Fleet';
import Process from '../components/Process/Process';
import Testimonials from '../components/Testimonials/Testimonials';
import ContactCTA from '../components/ContactCTA/ContactCTA';
import CargoCommitment from '../components/Cargocommitment/Cargocommitment';

export default function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <CargoCommitment />
      <AboutIntro />
      <Services compact />
      <WhyChooseUs />
      <Fleet />
      <Process />
      <Testimonials />
      <ContactCTA />
    </>
  );
}
